import React, {Component} from 'react';
import {dispatch, connect} from 'react-redux'
import {signInAction} from '../actions/creators'
import {Redirect} from 'react-router';
import {Modal} from 'react-bootstrap';
import {Checkbox, Button} from 'react-bootstrap';
import {HashLink as Link} from 'react-router-hash-link';

require('es6-promise').polyfill();
require('isomorphic-fetch');


class SignInForm extends Component {
    constructor() {
        super();
        this.state = {
            user_name: '',
            email: '',
            login: false,
            show: false,
            notFound: false,
            modalValue: 'test'
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleShow() {
        this.setState({show: true});
    }

    handleClose() {
        this.setState({show: false});
        document.body.style.cursor = 'default';
    }

    ValidateEmail(mail) {
        if (/^(.+)@(.+)(\.).+$/.test(mail)) {
            return (true)
        }
        return (false)
    }

    btnTapped(e) {
        var isDataValid = true;
        // document.body.style.cursor='wait';
        e.preventDefault();
        var url = this.props.serverUrl + '/v1/document-download/signIn';
        var email = document.getElementById("email").value;
        var planId = document.getElementById("planId").value;

        var planEin = document.getElementById("planEin").value;
        var checkbox = document.getElementById("agree").checked;
        var taxYear = document.getElementById("taxYear").value;

        if (checkbox == false) {
            isDataValid = false;
            this.setState({modalValue: 'Please read the terms of service, then check the box to continue.'});
            this.handleShow();
        }

        if (planEin == "") {
            isDataValid = false;
            this.setState({modalValue: 'Enter a enter plan EIN'});
            this.handleShow();
        }
        if (planId == "") {
            isDataValid = false;
            this.setState({modalValue: 'You must enter a Plan Id'});
            this.handleShow();
        }
        if (email == "") {
            this.ValidateEmail(email)
            isDataValid = false;
            this.setState({modalValue: 'Enter an E-mail address'});
            this.handleShow();
        }
        else {
            if (this.ValidateEmail(email) == false) {
                isDataValid = false;
                this.setState({modalValue: 'Enter a valid email address'});
                this.handleShow();
            }
        }

        if (isDataValid == true) {
            fetch(url,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: "POST",
                    body: JSON.stringify({
                        email: email,
                        year: taxYear,
                        planId: planId,
                        planEin: planEin
                    })
                }).then((response) => {
                let clone = response.clone();
                if (response.status == "200") {
                    this.state.login = true;
                    clone.json().then(json => {
                     //   console.log(JSON.stringify(json.document));
                    //   json.document = JSON.stringify(json);
                        this.props.signInAction(json);
                    });
                }
                else if (response.status == "400" || response.status == "401" || response.status == "404") {
                    this.setState({notFound: true})
                }
                else {
                    this.state.modalValue = "Something went wrong. Please try again!";
                    this.handleShow();

                }
            })
                .catch((error) => {
                    this.state.modalValue = "Something went wrong. Please try again!";
                    this.handleShow();
                });
        }
    }


    render() {

        if (this.props.returnStatus == "INPROGRESS") {
            return (<Redirect to="/welcome"/>)
        }

        if (this.props.returnStatus == "COMPLETE") {
            return (<Redirect to="/review_status"/>)
        }

        if (this.state.notFound == true) {
            return (<Redirect to="/not_found"/>)
        }

        return (
            <div align="left">
                <h4><font color="green"><b>Sign In</b></font></h4>
                <br/>
                <form onSubmit={this.handleSubmit}>
                    <label htmlFor="username">Enter E-mail Address:</label>
                    <br/>
                    <input id="email" name="email" type="email" required/>
                    <br/>
                    <label style={{marginTop: 5}} htmlFor="setTaxYear">Select TaxYear:</label>
                    <br/>
                    <select name="taxYear" id="taxYear">
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                    </select>
                    <br/>
                    <label style={{marginTop: 5}} htmlFor="birthdate">Plan ID</label>
                    <br/>
                    <input id="planId" name="planId" maxlength = "3" style={{width: 60}} required/>
                    <br/>
                    <label htmlFor="birthdate">Plan EIN</label>
                    <br/>
                    <input id="planEin" name="planEin" maxlength = "10" required/>
                    <br/>
                    <div style={{marginTop: 5, marginBottom: 0}}>
                        <Checkbox id="agree" required requiredmessage="Name is required."> I agree to the <Link
                            to="/tnc">Terms of Service</Link></Checkbox>
                        <br/>
                    </div>
                    <div style={{marginTop: 5}}>
                        <button type="submit" value="Submit" className="custom-btn-sign-in"
                                onClick={e => this.btnTapped(e)}>Submit
                        </button>
                    </div>
                </form>
                <Modal show={this.state.show} onHide={this.handleClose} animation={false}>

                    <Modal.Body>{this.state.modalValue}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12 text-center">
                            <Button variant="secondary" bsClass="close-button" onClick={this.handleClose}>
                                Close
                            </Button>
                        </div>

                    </Modal.Footer>
                </Modal>

            </div>

        );
    }
}


const mapStateToProps = (state) => {

    return {
        userName: state.userName,
        login: state.login,
        loginCount: state.loginCount,
        serverUrl: state.serverUrl,
        returnStatus: state.returnStatus
    }

};


const mapDispatchToProps = dispatch => {
    return {
        signInAction: (state) => {
            dispatch(signInAction(state))
        }

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(SignInForm);